import { useTranslation } from 'react-i18next';
import React, {useState, useEffect,Fragment,useRef} from 'react';
import {useNavigate,} from "react-router-dom";
import apiRequest from '../../functions/api';
import { Table,TableBody,TableCell,TableContainer,TableHead,TableRow, Grid, Hidden,Box,Button,IconButton} from "@mui/material";
import LoadingComponent from '../LoadingComponent/LoadingComponent';
import { useMessage } from '../../context/message-context';
import Page from "../shared/components/PageComponent";
import Layout from "../shared/components/LayoutComponent";
import DeleteIcon from "@mui/icons-material/Delete"
import GroupIcon from "@mui/icons-material/Group"
import axios from 'axios';
import {API_BASE_URL} from '../../constants/apiConstants';
import openFile from "../shared/functions/download";
import {FullPageSpinner} from '../lib';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import MessageBox from "../shared/components/MessageBox";
import InputBox from '../shared/components/InputBox';
import FindInPageIcon from '@mui/icons-material/FindInPage';
function MandatoryDocNew(props) {
  const { t } = useTranslation();
    const navigate = useNavigate();
    const [doks, setDoks] = useState([]);
    const { accessToken,  client} = props;
    const [isLoading, setIsLoading] = useState(false);
    const {hideMessage, showErrorMessage,showSuccessMessage} = useMessage();
    const [showModal, setShowModal] = useState(false);
    const [msgbox,setMsgBox] = useState(false);
    const pflichtdok_key = useRef("");
    const pflichtdok_bez = useRef("");
    const auswahl_fragen = useRef([]);
    const [editDialogOpen, setEditDialogOpen] = useState(false);
    
    useEffect(() => {
        Hole_Pflichtdok("")
    // eslint-disable-next-line
    }, [])
      
    const Hole_Pflichtdok = (pflichtdok) => {
        setIsLoading(true);
        const payload={
          "mandant": client,
          "program": "WEBPDS",
          "statement": "HOLE_DOKUMENTE",
          "pflichtdok":pflichtdok,
        }
        const headers={
          "Authorization": "Bearer "+accessToken,
        }
        apiRequest('POST', 'daten', payload, headers, PflichtdokcB,errorcB);
      }
    const PflichtdokcB = (response) => {
      setIsLoading(false);
      pflichtdok_key.current="";
      if (response.status === 200) {
          if (response.data.doks) {
            setDoks(response.data.doks);
          } else {
            setDoks([]);
          }
          hideMessage();
      } else {
          if (response) {
            showErrorMessage(response.data.message);
          } else {
            showErrorMessage(t("Keine Internetverbindung"));
          }
      }      
    }
   const loeschen = () => {
     Hole_Pflichtdok(pflichtdok_key.current)
   }
    const anzeigen = (dokkey,dokbez) => {
      const payload={
          "mandant": client, 
          "program": "WEBPDS",
          "statement": "ANZEIGEN",
          "pflichtdok":dokkey,
      }
      const headers={
          "Authorization": "Bearer "+accessToken,
          "Accept": "application/pdf"
      }
      axios.post(API_BASE_URL+'daten', payload, {headers: headers, responseType: 'blob'})
  
      .then((response) => {
        console.log(response);
        var fileName = dokbez;
        var contentFile = response.data;
        const mimeType = response.headers['content-type'] || 'application/pdf'
        openFile(fileName, contentFile,mimeType);
        closeModal();
      })
      .catch(function (error) {
        console.log(error);
        closeModal();
        showErrorMessage(t("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."));
      });    
    }
    const inputBoxResult = (results) => {
      setIsLoading(true);
      const payload={
        "mandant": client, // this.props.client,
        "program": "WEBPDS",
        "statement": "FRAGEN_EDIT",
        "antworten": results
      }
      const headers={
        "Authorization": "Bearer "+accessToken,
      }
      apiRequest('POST', 'daten', payload, headers, resultCb, errorcB);
    }
  
    const resultCb = (response) => {
      setIsLoading(false);
      if (response.status === 200) {
        showSuccessMessage(t("Ihre Änderungen wurden übernommen"));
        setEditDialogOpen(false);
        if (response.data.doks) {
          setDoks(response.data.doks);
        } else {
          setDoks([]);
        }
      } else {
        showErrorMessage(response.data.message);
      }
    }
    const errorcB = () => {
        setIsLoading(false);
        showErrorMessage(t("Keine Internetverbindung. Bitte erneut versuchen"));
    }
    const closeModal = () => {
      setShowModal(false);
    }
    const messageBoxResult = (result) => {  
      if (result === 'YES') {
        loeschen();
      }
      setMsgBox(false)
    }
        
    if (msgbox) {
      return(
        <MessageBox 
          open={msgbox}
          handleResponse={messageBoxResult}
          buttons="YESNO"
          text={"Soll das Pflichtdokument" + pflichtdok_bez.current + "wirklich gelöscht werden?"}
          title={t("Löschbestätigung")}
          onClose={() => setMsgBox(false)}
        />
      )  
    }
    if (isLoading) {
        return <LoadingComponent />
    }
    
    const aktion = (aktion,element) => {
      if (aktion==="vorschau") {
        navigate("/WEBPDB/pflichtdoc/confirm/"+element.key,{state: { vorschau: "J" }})
        navigate()
      }
      if (aktion==="anzeigen") {
        anzeigen(element.key,element.filename)
      } 
      if (aktion==="mitarbeiter") {
        navigate("/WEBPDS/"+element.key)
      }
      if (aktion==="edit") {
        auswahl_fragen.current=element.fragen;
        pflichtdok_bez.current=element.bez;
        setEditDialogOpen(true);
      }
      if (aktion==="löschen") {
        pflichtdok_key.current=element.key;
        pflichtdok_bez.current=element.bez;
        setMsgBox(true);
      }
    }
    const pflichtdokszeichnen = (doks.length>0) && doks.map((element, count) => {
       return (
       <TableRow>
          <TableCell> {element.bez} </TableCell>
          <TableCell> {element.gbis} </TableCell>
          <TableCell> {element.antworten} </TableCell>
            <TableCell> 
              <IconButton color="primary" onClick={()=> aktion("vorschau",element)} > <FindInPageIcon/> </IconButton>
              <IconButton color="primary" onClick={()=> aktion("anzeigen",element)} > <VisibilityIcon/> </IconButton>
              <IconButton color="primary" onClick={()=> aktion("mitarbeiter",element)} > <GroupIcon/> </IconButton>
              <IconButton color="primary" onClick={()=> aktion("edit",element)} > <EditIcon/> </IconButton>
              <IconButton color="primary" disabled={element.loeschen!=="1"} onClick={()=> aktion("löschen",element)} > <DeleteIcon/> </IconButton>
            </TableCell> 
       </TableRow>
      )
    })
  return (
    <Fragment>
    <Page>
    <Layout>
      <Box p={2}>
        <Grid container justifyContent="center">
          <Grid item xs={12}>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6}>
                <Button fullWidth color="primary" variant="contained" onClick={() =>     navigate("/interview/IV0087",{state: { programm: "WEBPDS" }})} >{t("Neues Pflichtdokument erstellen")}</Button>
              </Grid>
              <Grid item xs={12}>
                  <TableContainer>
                    <Table> 
                      <Hidden smDown> 
                        <TableHead>
                          <TableRow>
                            <TableCell>{t("Bezeichnung")}</TableCell>
                            <TableCell>{t("inaktiv ab")}</TableCell>
                            <TableCell>{t("Verknüpfte Mitarbeiter (bereits bestätigt/alle)")}</TableCell>
                            <TableCell>{t("Aktionen")}</TableCell>             
                          </TableRow>
                        </TableHead> 
                      </Hidden>         
                      <TableBody>
                        {pflichtdokszeichnen}
                      </TableBody> 
                    </Table>
                  </TableContainer>
                </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Layout>
    </Page>
    <InputBox
      open={editDialogOpen}
      handleResponse={inputBoxResult}
      fragen={auswahl_fragen.current}
      title={'Fragenanpassung für das Pflichtdokument '+pflichtdok_bez.current}
      onClose={() => setEditDialogOpen(false)}        
     />
    {showModal && <FullPageSpinner/>}
    </Fragment>
  )
}
export default MandatoryDocNew; 
